export default "__VITE_ASSET__72db3634__"